module.exports = __webpack_public_path__ + "static/media/schrank_loesung_bg.ce3a5d9c.jpg";